import momentTz from 'moment-timezone';
import moment, { Moment, MomentInput } from 'moment';

export function isBeforeCalendarWeekPublishing(
  fromBidcomp?: boolean,
  now?: MomentInput
): boolean {
  const timeZone = 'America/New_York';
  const publishingDateTime = fromBidcomp
    ? momentTz.tz(`${moment(now).day(5).format('YYYY-MM-DD')} 17:00`, timeZone)
    : momentTz.tz(`${moment(now).day(4).format('YYYY-MM-DD')} 14:00`, timeZone);
  const currentDateTime = momentTz.tz(moment(now), timeZone);
  return currentDateTime.isBefore(publishingDateTime);
}

export function getForwardCalendarWeekOf(
  fromBidcomp?: boolean,
  now?: MomentInput
): Moment {
  return moment(now)
    .day(1)
    .add(isBeforeCalendarWeekPublishing(fromBidcomp, now) ? 1 : 2, 'w');
}

export function isForwardCalendar(
  date: Moment,
  now?: MomentInput,
  fromBidcomp?: boolean
): boolean {
  return date.isSame(getForwardCalendarWeekOf(fromBidcomp, now), 'day');
}
